// app/frontend/services/auth/authService.js
import { useUserStore } from '@/stores/user';
import envConfig from '@/config/envConfig';
import { useMessageStore } from '@/stores/message.js';
import apiService from '@/services/apiService.js';
import { cookieService } from '@/services/cookieService.js';

class AuthService {

    async fetchProviders() {
        const res = await apiService.get('/auth/providers');
        return res?.data?.data?.providers ?? [];
    }

    get appState() {
        return {
            deviceId: cookieService.get(),
            logOutUri: envConfig.API_LOGOUT_URL,
            logOutUriDevice: envConfig.API_DEVICE_LOGOUT_URL,
        };
    }

    async fetchCurrentUser() {
        try {
            const res = await apiService.post('/login-check');
            if (res?.status === 200 && res.data?.data?.user) {
                let userData = res.data.data.user;

                return (userData && typeof userData === 'object') ? userData : null;
            }
            return null;
        } catch {
            return null;
        }
    }

    logout() {
        const userStore = useUserStore();

        if (userStore.isLoggedIn) {
            userStore.clearUser();
            userStore.resetLoginRedirectUrl();
            window.location.href = '/sign_out';
        }
    }
}

export default new AuthService();